import React, { useEffect, useState } from "react";
import moment from "moment";
import URL from "../../../../Main/url";
import CurrencyWord from "../../../../Componets/Currencywords";

const A4Invoice = React.forwardRef((props, ref) => {
  const { values } = props;

  const injectScopedStyles = () => {
    const style = document.createElement("style");
    style.innerHTML = `
      @page {
        size: A4;
        margin: 6% 6% 16% 6%;
         @bottom-left {
          font-size: 12px;
          content: "\\A \\A \\A \\A Customer's Signature (Name/Designation/Co. Seal) \\A \\A \\A";
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
        @bottom-right {
          font-size: 12px;
          content: "\\A \\A \\A \\A For ${values?.branch?.name} \\A \\A " counter(page) " of " counter(pages);
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
  
      @media print {
        .a4-invoice-footer {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          left: 6%;
        }
  
        .a4-invoice-footer-right {
          font-size: 12px;
          white-space: pre;
          position: fixed;
          bottom: 10mm;
          right: 6%;
        }
      }
    `;
    document.head.appendChild(style);
  };

  useEffect(() => {
    if (values?.branch?.name) {
      injectScopedStyles();
    }
  }, [values?.branch?.name]);

  return (
    <div className="px-24">
      <div className="" ref={ref}>
        <div>
          {/*letter header */}
          <div className="text-black-900 text-[0.65rem] text-center">
            <div className="text-center">
              {values?.branch?.image ? (
                <div className="flex justify-center">
                  <div className="text-xl pb-2">
                    <img
                      className="w-[50px] h-[50px]"
                      src={`${URL}/uploads${values?.branch?.image}`}
                    />
                  </div>
                </div>
              ) : (
                ""
              )}
              <div className="text-medium text-xl">{values?.branch?.name}</div>
              <div className="text-medium">{values?.branch?.category}</div>
            </div>
          </div>
          <div className="text-black-900 text-[0.65rem] text-center pt-4">
            <span>
              Email&nbsp;:&nbsp;
              {values?.branch?.email ? values?.branch?.email + ", " : ""}
              &nbsp;
            </span>
            <span>
              Phone&nbsp;:&nbsp;
              {values?.branch?.phone ? values?.branch?.phone : ""}
              &nbsp;
            </span>
            <div>
              {values?.branch?.area ? values?.branch?.area + ", " : ""}
              {values?.branch?.city ? values?.branch?.city + ", " : ""}
              {values?.branch?.country ? values?.branch?.country : ""}
            </div>
            <div>
              VATIN&nbsp;:&nbsp;
              {values?.branch?.tax ? values?.branch?.tax : "N/A"}
            </div>
          </div>
          {/*letter header end */}
          {/* heading */}
          <hr className="my-4 border-t-black-900 border-black" />
          <div className="text-medium text-xl text-center">TAX INVOICE</div>
          <div className="text-[0.60rem] pb-6">
            <div className="flex justify-between">
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td className="">
                        {values?.customer?.name
                          ? values?.customer?.name
                          : "Walk-in-customer"}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {values?.customer?.phone
                          ? "Phone : " + values?.customer?.phone
                          : ""}
                        &nbsp;
                        {values?.supplier?.email
                          ? ", Email : " + values?.customer?.email
                          : ""}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {values?.customer?.city
                          ? values?.customer?.city + ", "
                          : " "}
                        {values?.customer?.state}
                      </td>
                    </tr>
                    <tr>
                      <td>{values?.customer?.country}</td>
                    </tr>
                    <tr>
                      <td>
                        {values?.customer?.tax
                          ? "VATIN : " + values?.customer?.tax
                          : ""}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div>
                <table>
                  <tbody>
                    <tr>
                      <td>Invoice No</td>
                      <td className="px-2">:</td>
                      <td className="text-right">#INV-{values?.number}</td>
                    </tr>
                    <tr>
                      <td>Invoice Type</td>
                      <td className="px-2">:</td>
                      <td className="text-right">
                        {values?.payment_status == 2
                          ? values?.payments
                              ?.map((v, i) => (i > 0 ? ", " : "") + v?.name)
                              .join("")
                          : "CREDIT"}
                      </td>
                    </tr>
                    <tr>
                      <td>Date</td>
                      <td className="px-2">:</td>
                      <td className="text-right">
                        {moment?.(values?.date)?.format?.("DD-MM-YYYY")}
                      </td>
                    </tr>
                    {values?.due_date ? (
                      <tr>
                        <td>Due Date</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {moment?.(values?.due_date)?.format?.("DD-MM-YYYY")}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {values?.lpo_number ? (
                      <tr>
                        <td>Lpo No</td>
                        <td className="px-2">:</td>
                        <td className="text-right">{values?.lpo_number}</td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {values?.lpo_date ? (
                      <tr>
                        <td>Lpo Date</td>
                        <td className="px-2">:</td>
                        <td className="text-right">
                          {moment?.(values?.lpo_date)?.format?.("DD-MM-YYYY")}
                        </td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {values?.salesman?.name ? (
                      <tr>
                        <td>Salesman</td>
                        <td className="px-2">:</td>
                        <td className="text-right">{values?.salesman?.name}</td>
                      </tr>
                    ) : (
                      ""
                    )}
                    {/* <tr>
                    <td>Phone</td>
                    <td className="px-2">:</td>
                    <td className="text-right">N/A</td>
                  </tr> */}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          {/* table */}
          <div className="">
            <table className="w-full">
              <thead className="bg-black">
                <tr className="text-[0.60rem]">
                  <th className="font-normal  text-white  text-left py-2 pl-3">
                    <div className="text-[0.60rem]">S.NO</div>
                    {/* <div>ر.ت</div> */}
                  </th>
                  <th className="font-normal text-white text-left p-2">
                    <div className="text-[0.60rem]">DESCRIPTION</div>
                    {/* <div>الوصف</div> */}
                  </th>
                  <th className="font-normal text-white text-center p-2">
                    <div className="text-[0.60rem]">UNIT</div>
                    {/* <div>الوحدة</div> */}
                  </th>
                  <th className="font-normal text-white text-center p-2">
                    <div className="text-[0.60rem]">QTY</div>
                    {/* <div>الكمية</div> */}
                  </th>
                  <th className="font-normal text-white text-center p-2">
                    <div className="text-[0.60rem]">RET.PRICE</div>
                    {/* <div>سعر التجزئة</div> */}
                  </th>
                  <th className="font-normal text-white text-center p-2">
                    <div className="text-[0.60rem]">W.S&nbsp;PRICE</div>
                    {/* <div>سعر الجملة</div> */}
                  </th>
                  <th className="font-normal text-white text-center p-2">
                    <div className="text-[0.60rem]">DISC</div>
                    {/* <div>مجاني</div> */}
                  </th>
                  <th className="font-normal text-white text-center p-2">
                    <div className="text-[0.60rem]">FOC</div>
                    {/* <div>مجاني</div> */}
                  </th>
                  <th className="font-normal text-white text-center p-2">
                    <div className="text-[0.60rem]">VAT</div>
                    {/* <div>الضريبة</div> */}
                  </th>
                  <th className="font-normal text-white text-right pr-2">
                    <div className="text-[0.60rem]">TOTAL</div>
                    {/* <div>الإجمالي</div> */}
                  </th>
                </tr>
              </thead>
              {/* table body */}
              <tbody className="text-sm">
                {values?.details?.map((value, index) => {
                  return (
                    <tr className="uppercase border-b border-gray-300 ">
                      <td className="text-[0.60rem] leading-[0.75rem] align-top">
                        <div className="pl-3">{index + 1}</div>
                      </td>
                      <td className="text-left leading-[0.75rem] align-top">
                        <div className="text-[0.60rem] p-0 m-0 text-medium">
                          {value?.name}
                        </div>
                        <div className="text-gray-500 p-0 m-0 text-[0.60rem]">
                          #BATCH-{value?.description?.number}
                        </div>
                        <div className="text-gray-500 p-0 m-0  text-[0.60rem]">
                          {value?.expiry_date
                            ? `Expiry : ${moment?.(value?.expiry_date)?.format(
                                "DD-MM-YYYY"
                              )}`
                            : ""}
                        </div>
                      </td>
                      <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                        {value?.unit_name}
                      </td>
                      <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                        {value?.quantity}
                      </td>
                      <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                        {value?.description?.sale_price?.toFixed(3)}
                      </td>
                      <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                        {value?.sale_price?.toFixed(3)}
                      </td>
                      <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                        <div className="text-[0.60rem]">
                          {value?.discount_percentage}%
                        </div>
                        <div className="text-[0.60rem] text-gray-500 leading-[0.75rem] align-top">
                          {value?.discount_price?.toFixed?.(3)}
                        </div>
                      </td>
                      <td className="text-center text-[0.60rem] leading-[0.75rem] align-top">
                        {value?.free ? value?.free : 0}
                      </td>
                      <td className="text-center leading-[0.75rem] align-top">
                        <div className="text-[0.60rem] ">{value?.tax}%</div>
                        <div className="text-[0.60rem] text-gray-500">
                          {value?.tax_amount?.toFixed(3)}
                        </div>
                      </td>
                      <td className="text-right text-[0.60rem] leading-[0.75rem] align-top">
                        {value?.total?.toFixed(3)}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
              {/* table foot */}
              <tfoot className="text-xs text-medium leading-[0.75rem]">
                <tr>
                  <th colSpan={8}></th>
                  <th className="font-normal text-right p-[4px]">Subtotal</th>
                  <td className="font-normal text-right p-[4px]">
                    {values?.subtotal?.toFixed(3)}
                  </td>
                </tr>
                <tr>
                  <th colSpan={8}></th>
                  <th className="font-normal text-right p-[4px]">VAT (5%)</th>
                  <td className="font-normal text-right p-[4px]">
                    {values?.taxamount?.toFixed(3)}
                  </td>
                </tr>
                <tr>
                  <th colSpan={8}></th>
                  <th className="font-normal text-right p-[4px]">Discount</th>
                  <td className="font-normal text-right p-[4px]">
                    {values?.discount_type
                      ? values?.discount_value
                        ? `${values?.discount?.toFixed(3)} (-${
                            values?.discount_value
                          }%)`
                        : "0.000"
                      : values?.discount
                      ? `-${values?.discount?.toFixed(3)}`
                      : "0.000"}
                  </td>
                </tr>
                {values?.delivery ? (
                  <tr>
                    <th colSpan={8}></th>
                    <th className="font-normal text-right p-[4px]">
                      Delivery Charge
                    </th>
                    <td className="font-normal text-right p-[4px]">
                      +{values?.delivery?.toFixed(3)}
                    </td>
                  </tr>
                ) : (
                  ""
                )}
                <tr>
                  <th colSpan={8}></th>
                  <th className="font-normal text-right text-white bg-black p-[4px]">
                    Total&nbsp;(OMR)
                  </th>
                  <td className="font-normal text-right text-white bg-black p-[4px]">
                    {values?.total?.toFixed(3)}
                  </td>
                </tr>
              </tfoot>

              {/* <tfoot className="text-sm ">
                <tr className="">
                  <th colSpan={8}></th>
                  <th className="font-normal pt-1 text-right p-1 text-[0.60rem]">
                    Subtotal
                  </th>
                  <td className="font-normal text-right p-1 text-[0.60rem]">
                    {values?.subtotal?.toFixed(3)}
                  </td>
                </tr>
                <tr>
                  <th colSpan={8}></th>
                  <th className="font-normal text-right p-1 text-[0.60rem]">
                    VAT (5%)
                  </th>
                  <td className="font-normal text-right p-1 text-[0.60rem]">
                    {values?.taxamount?.toFixed(3)}
                  </td>
                </tr>
                <tr>
                  <th colSpan={8}></th>
                  <th className="font-normal text-right p-1 text-[0.60rem]">
                    Discount
                  </th>
                  <td className="font-normal text-right p-1 text-[0.60rem]">
                    {values?.discount_type
                      ? values?.discount_value
                        ? values?.discount?.toFixed(3) +
                          " " +
                          "(-" +
                          values?.discount_value +
                          "%)"
                        : "0.000"
                      : values?.discount
                      ? "-" + values?.discount?.toFixed(3)
                      : "0.000"}
                  </td>
                </tr>
                {values?.delivery ? (
                  <tr>
                    <th colSpan={8}></th>
                    <th className="font-normal text-right p-1 text-[0.60rem]">
                      Delivery Charge
                    </th>
                    <td className="font-normal text-right p-1 text-[0.60rem]">
                      {values?.delivery
                        ? "+" + values?.delivery?.toFixed(3)
                        : "0.000"}
                    </td>
                  </tr>
                ) : (
                  ""
                )}
                <tr>
                  <th className="" colSpan={8}></th>
                  <th className="font-normal text-right text-white bg-black p-2 text-[0.60rem]">
                    Grand&nbsp;Total&nbsp;(OMR)
                  </th>
                  <td className="font-normal text-right text-white bg-black p-2 text-[0.60rem]">
                    {values?.total?.toFixed(3)}
                  </td>
                </tr>
              </tfoot> */}
            </table>
            <div className="text-[0.60rem] text-right pt-4">
              Total in words&nbsp;:&nbsp;
              <CurrencyWord amount={values?.total?.toFixed(3)} />
            </div>
          </div>
          {/* note */}
          <div className="pt-4 text-sm">
            <div className="">
              {/* <div className="font-semibold">Note&nbsp;&nbsp;</div>
                      <li>
                        Please feel free to contact us for any questions or concerns.
                      </li> */}
            </div>
            <div className="pt-4">
              {/* <div className="font-semibold">
                        Terms & Conditions&nbsp;&nbsp;
                      </div>
                      <li>Quote validity for 30 days.</li> */}
            </div>
          </div>
          {/* <div className="">
                      <div
                        className="page-footer mb-[1.5cm]"
                        style={{ padding: " 1.6cm" }}
                      >
                        <div className="flex justify-between px-[0.5cm]">
                          <div className="text-[0.65rem]">
                            Customer's Signature (Name/Designation/Co. Seal)
                          </div>
                          <div className="text-[0.65rem]">For New Pharmacy LLC</div>
                        </div>
                      </div>
                    </div> */}
        </div>
      </div>
    </div>
  );
});

export default A4Invoice;
